<template>
  <div>
    <el-dialog :visible.sync="dialogVisible"
               custom-class="jump-link-dialog"
               :show-close="false"
               width="50%">
      <h2 style="text-align:center;color: black; margin: 0;font-size: 16px">跳转说明</h2>
      <div style="font-size: 15px;margin: 10px 0;color: black">您正在跳转前往专业版数据库（魔镜CMI），<span style="font-weight: bolder; color: red">该数据库不支持镜界AI账号登录，需要CMI企业账号登录</span>（<span
              style="text-decoration: underline; color: blue;cursor: pointer"
              @click="routeTo('home')">申请试用CMI</span>）
      </div>
      <div style="width: 100%;text-align: center">
        <img :src="jumpImg"
             width="80%"
             style="text-align: center"
             alt="">
      </div>
      <div>

        <div style="font-size: 15px;margin: 10px 0;color: black">
          如您数据看板显示异常，请<span style="text-decoration: underline; color: blue; cursor: pointer"
                @click="contactHelp">联系客服</span>帮您解决
        </div>
      </div>
      <div style="text-align:center;margin-top: 20px">
        <el-button type="primary"
                   style="margin-right: 40px;padding: 7px 12px;border-radius: 8px"
                   @click="routeTo('home')">申请试用CMI数据库 <i class="iconfont icon-yousanjiao"></i></el-button>
        <el-button @click='routeTo("link")'
                   style="padding: 7px 12px;border-radius: 8px;border-color: #3A63F3;color: #3A63F3">确认跳转 <i class="iconfont icon-yousanjiao"></i></el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import { jumpToBlank } from '@/utils'
export default {
  name: '',
  data() {
    return {
      dialogVisible: false,
      jumpImg: require('@/assets/jumpLink.png'),
    }
  },
  props: {
    link: {
      type: String,
      default: '',
    },
  },
  computed: {},
  methods: {
    close() {},
    routeTo(type) {
      if (type == 'home') {
        jumpToBlank('https://www.mktindex.com?f=jingjie_a')
      } else if (type == 'link') {
        jumpToBlank(this.link)
      }
    },
    contactHelp() {
      this.$eventBus.$emit('showKfDialog')
    },
  },
  created() {},
}
</script>

<style lang="less">
.jump-link-dialog {
  border-radius: 10px !important;
  .el-dialog__header {
    padding: 0;
  }
}
</style>
